import { request } from "@umijs/max";
import { StreamResponseDataType } from "@/utils/streamFetch";

export type TextMessage = {
  type: "text";
  messageOutput: string;
};
export type FileMessage = {
  type: "file";
  name: string;
  url: string;
};
export type VideoInfoMessage = {
  type: "video";
  name: string;
  url: string;
};
export type ImageMessage = {
  type: "image";
  url: string;
};
export type CardMessage = {
  type: "card";
  headUrl: string;
  title: string;
  description: string;
  url: string;
};
export type VoiceMessage = {
  type: "voice";
  url: string;
};
export type ChatMessageType =
  | TextMessage
  | FileMessage
  | ImageMessage
  | CardMessage
  | VideoInfoMessage
  | VoiceMessage;

export function clearChatHistoryService(chatId: string) {
  return request<API.BaseResponse>(
    `/api/insnail-flow-platform/flow/runtime/test/clear-chat/${chatId}`,
    {
      method: "PUT",
    }
  );
}

export enum InterruptConversationEnum {
  /** 打断 */
  Interrupt = "1",
  /** 不打断 */
  NoInterrupt = "0",
}

export function getFlowDetailService(appId: string) {
  return request<
    API.BaseResponse<{
      name: string;
      description: string;
      interruptOldOnNew: `${InterruptConversationEnum}`;
      avatar: string;
    }>
  >(`/api/insnail-flow-platform/flow/management/${appId}?needAvatar=true`);
}

export function getShortLinkService(data: { url: string }) {
  return request<API.BaseResponse<{ shortLinkUrl: string }>>(
    "/api/blade-gateway/shortlink-service/short-link",
    {
      method: "POST",
      data,
    }
  );
}

export function chatHistoryService(chatId: string) {
  return request<API.BaseResponse<{ name: string }>>(
    `/api/insnail-flow-platform/flow/runtime/test/chat/${chatId}`
  );
}

/** 查询欢迎语 */
export function queryWelcomeWordsService(flowId: string, chatId: string) {
  return request<API.BaseResponse<StreamResponseDataType[]>>(
    `/api/insnail-flow-platform/flow/runtime/test/chat/${flowId}/welcome`,
    {
      params: { chatId },
    }
  );
}

/**
 * 上传文件接口
 * @param file
 * @returns
 */
export function postUploadFile(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return request<API.BaseResponse<{ url: string }>>(
    "/api/insnail-file-service/auth-api/publicFile?serviceNo=16",
    {
      method: "POST",
      data: formData,
    }
  );
}
